export default __webpack_public_path__ + "static/media/gallery_06.aba1815b.jpg";